import React, { useState } from "react";
import '../styles/otherpatient.css';
import enterOtpBg from '../assets/images/patient-image.jpg';
import PrimaryButton from "../components/inputs/PrimaryButton";
import { Api } from "../api/Api";
import { showToast } from "../helpers/UIHelper";
import useCustomNavigate from "../hooks/useCustomNavigate";
import PageHeader from "../components/PageHeader";

const OtherPatient = (props) => {
    const [logging, setLogging] = useState(false);
    const [mrn, setMrn] = useState('');
    const navigate = useCustomNavigate();
    const [patient, setPatient] = useState(null);
    const confirm = () => {
        setPatient(null);
        setLogging(true);
        Api.post('/weblogin', { method: 'findpatient', mrno:mrn }).then((resp) => {
            if (resp.status === 200) {
                if (!resp.error) {
                    if (resp.data.patient) {
                        setPatient(resp.data.patient);
                    } else {
                        showToast('error', 'No Patients Found')
                    }
                } else {
                    showToast('error', resp.error);
                }
            }
        }).catch((e) => {
            showToast('error','Failed to find patient')
            setLogging(false);
        }).finally(() => {
            setLogging(false);
        });
    }
    
    const onPatientSelect = () => {
        localStorage.setItem("life-other-patient", JSON.stringify(patient));
        navigate('/departments', {forOtherPatient:true});
    }

    return (
        <>
        <div className="mrn-login-container">
            <PageHeader title="Book For Others"/>        
            <div className="image-container">
                <img src={enterOtpBg} alt="login-bg"/>
            </div>
            <div className="text-container">
                <div className="main-text">Find By UHID</div>
                <div className="sub-text">Please enter an UHID to continue</div>
            </div>
            <div className="bottom-container">
                <div className="form-container">
                    <div className="entry-field-container">
                        <input type="text" className="mrn-field" value={mrn} onChange={(e) => { setMrn(e.target.value); }}/>
                    </div>
                </div>
                <div className="form-container">
                    <PrimaryButton label="Continue" isLoading={logging} onClick={confirm} />    
                </div>
                {patient ?        
                    <div className="patient-found-item" onClick={onPatientSelect}>
                        <div className="patient-name">
                            <div className="name">{patient.patientName}</div>
                            <div className="mrno">{patient.mrnNo}</div>
                        </div>
                        <div className="action-container">
                            <i className="las la-angle-right"/>
                        </div>
                    </div>:<></>
                }    
            </div>
        </div >
        </>
    )
}
export default OtherPatient;